import { makeStyles, ThemeProvider } from "@material-ui/core/styles";
import { SnackbarProvider } from "notistack";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { useAuthContext } from "../auth/AuthProvider";
import { requestA7Products } from "../stores/a7products/A7ProductsAction";
import * as BasketAction from "../stores/basket/BasketAction";
import * as CountriesAction from "../stores/countries/CountriesAction";
import { requestProducts } from "../stores/products/ProductsAction";
import * as UserDetailsAction from "../stores/user/UserDetailsAction";
import * as BusinessPartnerAction from "../stores/businessPartners/BusinessPartnerAction";
import { CookieBar } from "./components/Cookies/CookieBar";
import { Footer } from "./components/Footer/Footer";
import { HeaderBar } from "./components/Header/HeaderBar";
import { mainNavBarItems } from "./components/Header/MainNavBarItems";
import { NavBar } from "./components/Header/Navbar";
import LogoutIdleTimer from "./components/LogoutTimer/LogoutIdleTimer";
import { MainContent } from "./components/MainContent/MainContent";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import { Toasts } from "./components/Toasts/Toasts";
import { LocalStorageProducts } from "./components/LocalStorageProducts/LocalStorageProducts";
import { ModulePricing } from "./components/ModulePricing/ModulePricing";
import { routes } from "./Routes";
import theme from "./theme";
import { isAdminUser } from "../utilities/userUtils";

const useStyles = makeStyles((t) => ({
    root: {
        font: "font-family: clearSans_light,Arial,Verdana,Helvetica,sans-seriff",
        paddingBottom: "178px" // footer height
    },
}));

const App = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const authContext = useAuthContext();
    const userId = authContext?.user?.id;

    useEffect(() => {
        dispatch(requestProducts());
        dispatch(requestA7Products());
        dispatch(CountriesAction.requestCountries());
        dispatch(BasketAction.requestBasket(userId));

        if (userId) {
            dispatch(UserDetailsAction.initUser(userId));
            dispatch(BasketAction.requestBasket(userId));
            dispatch(UserDetailsAction.requestCurrentUser(userId));
            if (isAdminUser(authContext)) {
                dispatch(BusinessPartnerAction.requestAllBusinessPartners());
            }
        }
    }, [dispatch, userId, authContext]);

    return (
        <ThemeProvider theme={theme}>
            <div className={classes.root}>
                <SnackbarProvider
                    autoHideDuration={10000}
                    maxSnack={5}
                    dense={false}
                >
                    <BrowserRouter>
                        <ModulePricing />
                        <LocalStorageProducts />
                        <LogoutIdleTimer />
                        <ScrollToTop />
                        <CookieBar />
                        <HeaderBar />
                        <NavBar menuItems={mainNavBarItems} />
                        <MainContent routes={routes} />
                        <Footer />
                        <Toasts />
                    </BrowserRouter>
                </SnackbarProvider>
            </div>
        </ThemeProvider>
    );
};

export default App;
